module.exports = __webpack_public_path__ + "static/media/factoryList-03.86853ac0.png";